import { gql } from '@apollo/client';

import { PracticeSubject } from '../../types';

export interface GetAvailableExercisesForPracticeVariables {
  courseId: string;
}

export interface GetAvailableExercisesForPracticeResult {
  availableExercisesPayload: { availableExercises: number; subjects: PracticeSubject[] };
}

export const getAvailableExercisesForPracticeQuery = gql`
  query GetAvailableExercisesForPractice($courseId: String!) {
    availableExercisesPayload(courseId: $courseId) @rest(path: "courses/{args.courseId}/practice/available-exercises") {
      availableExercises
      subjects {
        name
        path
        exercises {
          _id
          id: _id
          code
          subject
          subjectPath
        }
      }
    }
  }
`;
